module.exports = __webpack_public_path__ + "fonts/Roboto-Thin1f35e6a11d27d2e10d28946d42332dc5.woff2]";